import {Map, fromJS} from 'immutable';
import * as actions from './actions'

const defaultState = Map({
    options: Map()
})

function reducer( state=defaultState, action) {
    switch (action.type) {
        case actions.EXCHANGE_READ_SUCCEEDED:
        case actions.EXCHANGE_CREATE_SUCCEEDED:
        case actions.EXCHANGE_DELETE_SUCCEEDED:
        case actions.EXCHANGE_UPDATE_SUCCEEDED:
        case actions.EXCHANGE_UPDATES_SUCCEEDED:
            return state.set('options', fromJS(action.payload))
        default:
            return state
      }
}

export default reducer



// WEBPACK FOOTER //
// ./src/model/Exchange/reducer.js